var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('i')])])
}
var staticRenderFns = []

export { render, staticRenderFns }